export default {
  name: 'Grüne',
  isRotated:
    true,
  versions:
    ['gruene/gruene_2.jpg', 'gruene/gruene_3.jpg'],
  containerStyle: {
    paddingBottom: '20%',
  },
  baseStyle:
    {
      fontFamily: '"Gotham Narrow", "Open Sans", sans-serif',
      letterSpacing:
        '-1px',
      textTransform:
        'uppercase',
      textAlign:
        'center',
      padding:
        '10px',
      display:
        'block',
      position:
        'relative',
      lineHeight:
        '0.8',
      transform: 'rotate(-5deg)',
      margin: '0 auto',
      width:
        '70%',
      textShadow:
        '0px 0px 10px rgba(0,0,0,0.3)',
      fontStyle:
        'italic',
      marginTop:
        '5px',
      marginBottom:
        '5px'
    }
  ,
  customStyles: [
    {
      name: "gelb",
      style: {
        color: '#FFF000'
      }
    },
    {
      name: "weiss",
      style: {
        color: '#FFF',
      }
    },
    {
      name: "pink",
      style: {
        color: '#fe01ac',
      }
    },
    {
      name: "grün",
      style: {
        color: 'rgb(132,180,20)'
      }
    }
  ],
  linesDefault:
    [
      {
        text: 'WER GRANTLT RUM, WENN NICHT WIEN?',
        style: 0,
        fontSize: 60
      },
      {
        text: '#Wienistgleicher',
        style: 1,
        fontSize: 30
      }]
}



// WEBPACK FOOTER //
// ./src/config/gruene.js